<template>
    <div class="lb">
        <div ref="barMian" class="barMian"></div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: "template.scope111",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            title: "scope111-【组件】双柱图 - 舆情定制",
            timer: null,
            defaultdata: [
                {
                    value2: "A5.1治安家事件",
                    value3: "视频",
                    value4: "2.8",
                    value5: "新闻",
                    value6: "1.4",
                    value7: "人/天",
                },
                {
                    value2: "A5.2治安家事件",
                    value3: "视频",
                    value4: "2.1",
                    value5: "新闻",
                    value6: "1.4",
                },
                {
                    value2: "A5.3治安家事件",
                    value3: "视频",
                    value4: "3.1",
                    value5: "新闻",
                    value6: "1.4",
                },
                {
                    value2: "A5.4治安家事件",
                    value3: "视频",
                    value4: "2.8",
                    value5: "新闻",
                    value6: "1.4",
                },
                {
                    value2: "A5.5治安家事件",
                    value3: "视频",
                    value4: "2.1",
                    value5: "新闻",
                    value6: "1.4",
                },
            ],
            valueMap: [
                { name: "名称", key: "value2" },
                { name: "柱状图一图例", key: "value3" },
                { name: "柱状图一数据", key: "value4" },
                { name: "柱状图二图例", key: "value5" },
                { name: "柱状图二数据", key: "value6" },
                { name: "单位", key: "value7" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
        };
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                this.defaultdata = n;
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
            this.DrawEcharts();
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    methods: {
        ...methods,
        DrawEcharts() {
            clearInterval(this.timer);
            this.timer = null;
            var echarts = require("echarts");
            var TmyChart = echarts.init(this.$refs.barMian);
            let data1 = [];
            let data2 = [];
            let legend = [];
            let vdata = JSON.parse(JSON.stringify(this.defaultdata));
            let xData = [...new Set(vdata.map((item) => item.value2))];
            let xData2 = [...new Set(vdata.map((item) => item.value1))];
            let chartlist = xData2.map((item) => {
                let list = vdata.filter((del) => del.value1 == item);
                return { name: item, data: list };
            });
            chartlist[0].data.forEach((item, i) => {
                if (item.value3 && item.value4) {
                    const vdata1 = { name: item.value2, value: item.value4 };
                    data1.push(vdata1);
                }
                if (item.value5 && item.value6) {
                    const vdata2 = { name: item.value2, value: item.value6 };
                    data2.push(vdata2);
                }
                if (i == 0) {
                    if (item.value3) {
                        legend.push({
                            show: true,
                            top: "2%",
                            right: "50%",
                            itemHeight: 12, //图例的高度  文字左边那个
                            itemWidth: 10,
                            icon: "rect",
                            textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
                            data: [item.value3 || ""],
                        });
                    }
                    if (item.value5) {
                        legend.push({
                            show: true,
                            top: "2%",
                            left: "50%",
                            itemHeight: 12, //图例的高度  文字左边那个
                            itemWidth: 10,
                            icon: "rect",
                            textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
                            data: [item.value5 || ""],
                        });
                    }
                }
            });
            const percent = (7 / xData.length) * 100;
            let zoom = [
                {
                    id: "scope70", // 唯一的id
                    filterMode: "empty",
                    xAxisIndex: [0], //滑动条为竖
                    mayValueSpan: 7, // 显示数据的条数(默认显示10个)
                    type: "slider",
                    showDetail: false, //关闭：拖拽时候显示详细数值信息。
                    dataBackground: {
                        show: false,
                        lineStyle: {
                            opacity: 0,
                        },
                        areaStyle: {
                            opacity: 0,
                        },
                    },
                    moveHandleSize: 0,
                    selectedDataBackground: {
                        lineStyle: {
                            opacity: 0,
                        },
                        areaStyle: {
                            opacity: 0,
                        },
                    },
                    backgroundColor: "transparent",
                    fillerColor: "rgba(0,0,0,.2)",
                    borderColor: "transparent",
                    start: 0,
                    end: percent,
                },
            ];
            var Toption = {
                title: [
                    {
                        text: this.defaultdata[0].value7 || "",
                        top: "0",
                        left: "0",
                        textStyle: {
                            color: "#979AA0",
                            fontSize: 12,
                        },
                    },
                ],
                tooltip: {
                    trigger: "axis",
                },
                legend: [...legend],
                grid: {
                    left: "5px",
                    right: "10px",
                    bottom: "0px",
                    top: "40px",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: xData,
                    axisLabel: {
                        rotate: 45,
                        interval: 0,
                        margin: 12,
                        textStyle: {
                            color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
                            fontSize: "12",
                            lineHeight: 12,
                        },
                        formatter: function(value) {
                        // 插入换行符并在第二行截断
                            if(value.length > 6) {
                                return value.substring(0, 6) + '\n' + (value.length > 12 ? value.substring(6, 12) + '...' : value.substring(6));
                            }
                            return value;
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            // X 轴颜色配置
                            color: "#4792e9",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: {
                    splitNumber: 4, // 设置y轴刻度间隔个数
                    axisLabel: {
                        textStyle: {
                            color: "#979AA0", // 这里将 x 轴文本颜色设为灰白色
                        },
                    },
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "rgba(231,241,251,.2)",
                        },
                    },
                },
                series: [
                    {
                        data: data1,
                        type: "bar",
                        name: vdata[0].value3 || "",
                        barWidth: 15,
                        barGap: "40%",
                        label: {
                            normal: {
                                show: true,
                                position: "top",
                                color: "#0182fc",
                            },
                        },
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(
                                0,
                                0,
                                0,
                                1,
                                [
                                    {
                                        offset: 0,
                                        color: "#0182fc", // 0% 处的颜色
                                    },
                                    {
                                        offset: 0.8,
                                        color: "#0182fc", // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: "#08315f", // 100% 处的颜色
                                    },
                                ],
                                false
                            ),
                        },
                    },
                    {
                        data: data2,
                        type: "bar",
                        name: vdata[0].value5 || "",
                        barWidth: 15,
                        label: {
                            normal: {
                                show: true,
                                position: "top",
                                color: "#00e3e2",
                            },
                        },
                        barGap: "40%",
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(
                                0,
                                0,
                                0,
                                1,
                                [
                                    {
                                        offset: 0,
                                        color: "#00e3e2", // 0% 处的颜色
                                    },
                                    {
                                        offset: 0.8,
                                        color: "#00cbcc", // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: "#023742", // 100% 处的颜色
                                    },
                                ],
                                false
                            ),
                        },
                    },
                ],
                dataZoom: xData.length > 7 ? zoom : [],
            };
            Toption && TmyChart.setOption(Toption);
            this.timer = setInterval(() => {
                if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000);


        },
    },
    created() { },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData(); //需要刷新的数据
        this.DrawEcharts();
    },
};
</script>

<style scoped>
.lb {
    width: 435px;
    height: 240px;
    display: flex;
    position: relative;
    padding: 10px 0;
}

.barMian {
    width: 100%;
    height: 100%;
}
</style>